/* eslint-disable @typescript-eslint/ban-types */
import React from 'react';
import styled from 'styled-components';
import Checkbox from '@ui-elements/Checkbox';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import { CheckboxProps } from '@mui/material/Checkbox';
import { PALETTE } from '~/assets/styles/base';

const Wrapper = styled(Box)`
  width: 100%;
  background: none;
  border: none;
  color: ${PALETTE.black};
`;
const ResidenceWrapper = styled(Box)`
  display: flex;
`;

const Parent = styled(Box)`
  min-width: 120px;
  text-align: left;
  span {
    font-weight: bold;
  }
`;
const Children = styled(Box)`
  display: flex;
  flex-wrap: wrap;
`;

const ResidenceCheckAll = styled(Box)`
  width: 100%;
  text-align: left;
  span {
    font-weight: bold;
  }
`;

type ChildrenProps = {
  [key: string]: string;
};

type AreaProps = {
  areaCd: string;
  areaNm: string;
  children: ChildrenProps[];
};

type CheckedByParentsProps = {
  [key: string]: boolean;
};

type Props = {
  isAllChecked: boolean;
  isAllCheckedByParent: CheckedByParentsProps;
  areas: AreaProps[];
  checkedChoices: string[];
  handleCheckAllChange: CheckboxProps['onClick'];
  handleChoiceChange: Function;
  displayCheckAll?: boolean;
};

const ResidenceCheckBox: React.FC<Props & CheckboxProps> = ({
  isAllChecked,
  isAllCheckedByParent,
  areas,
  checkedChoices,
  handleChoiceChange,
  displayCheckAll = true,
  handleCheckAllChange,
}): JSX.Element => (
  <Wrapper data-testid="uiParts-ResidenceCheckBox">
    {displayCheckAll && (
      <ResidenceWrapper key="all-0">
        <ResidenceCheckAll>
          <Checkbox
            name="CheckAll"
            label="すべて選択"
            checked={isAllChecked}
            value="all"
            dataTestId="uiParts-ResidenceCheckBox-checkAll-all"
            handleChange={handleCheckAllChange}
            key="all-cb"
          />
        </ResidenceCheckAll>
      </ResidenceWrapper>
    )}
    <Divider variant="middle" />

    {areas.map((parent, i) => (
      <div key={`area-${i}`}>
        <ResidenceWrapper data-testid={`uiParts-ResidenceCheckBox-area-${i}`} key={`parent-${i}`}>
          <Parent>
            <Checkbox
              name="ResidenceCheckbox"
              label={parent.areaNm}
              value={parent.areaCd}
              checked={isAllCheckedByParent[parent.areaCd]}
              dataTestId={`uiParts-ResidenceCheckBox-checkAll-${i}`}
              handleChange={handleCheckAllChange}
              key={`parent-cb-${i}`}
            />
          </Parent>
          <Children>
            {parent.children.map((child, j) => {
              const isChecked =
                checkedChoices === undefined ? false : checkedChoices.includes(child.areaCd);
              return (
                <Checkbox
                  name="ResidenceCheckbox"
                  label={child.areaNm}
                  checked={isChecked}
                  value={`${child.parentAreaCd}-${child.areaCd}`}
                  dataTestId={`uiParts-ResidenceCheckBox-${child.parentAreaCd}-${j}`}
                  key={`child-cb-${j}-${i}`}
                  handleChange={(e) => handleChoiceChange(e)}
                />
              );
            })}
          </Children>
        </ResidenceWrapper>
        <Divider variant="middle" />
      </div>
    ))}
  </Wrapper>
);

export default ResidenceCheckBox;
